import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Dialog, RaisedButton, FlatButton } from 'material-ui';
import R from 'ramda';
import EZLoadImg from '../../../../www/images/ezload.png';
import injectCSS from 'react-jss';

const propTypes = {
  classes: PropTypes.object,
  open: PropTypes.bool,
  openEzLoadWizardFn: PropTypes.func,
  onRequestClose: PropTypes.func,
  openSendRatesWizardFn: PropTypes.func,
};

const styles = {
  dialogBody: {
    backgroundColor: '#607d8b',
  },
  body: {
    textAlign: 'center',
    color: '#fff',
  },
  actions: {
    marginTop: '16px',
  },
};

const EZLoadOffer = props => {
  const {
    open,
    openSendRatesWizardFn,
    openEzLoadWizardFn,
    onRequestClose,
    classes: css,
  } = props;
  return (
    <Dialog
      open={open}
      onRequestClose={onRequestClose}
      contentStyle={{ width: '550px', backgroundColor: 'transparent' }}
      bodyClassName={css.dialogBody}
      autoScrollBodyContent
    >
      <div className={css.body}>
        <div style={{ overflow: 'auto', width: '100px', height: '100px', borderRadius: '50%', backgroundColor: '#fff', margin: '16px auto 0' }}>
          <img
            src={EZLoadImg}
            style={{ marginTop: '20%', width: '65%' }}
          />
        </div>
        <h4 style={{ color: '#fff' }}>We will load your rates for free! No catch!</h4>
        <div>
          {`We know loading your rates and product information into a new system can be annoying. That’s why we’re willing to do it for you, for free! Just upload a file, we'll load it, then approve and send your rates to your partners!`}
        </div>
        <div className={`flex-tc-sb ${css.actions}`}>
          <FlatButton
            label="Send Rates"
            labelStyle={{ color: '#fff' }}
            onTouchTap={openSendRatesWizardFn}
          />
          <RaisedButton
            label="Sign Me Up"
            onTouchTap={openEzLoadWizardFn}
            labelStyle={{ color: '#607d8b', fontWeight: 'bold' }}
          />
        </div>
      </div>
    </Dialog>
  );
};

const mapStateToProps = ({}) => ({});

const mapDispatchToProps = dispatch => ({});
EZLoadOffer.propTypes = propTypes;
EZLoadOffer.contextTypes = {
  router: PropTypes.object.isRequired,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectCSS(styles)(EZLoadOffer));



// WEBPACK FOOTER //
// ./src/app/components/assets-landing/dialog/ezload-offer.jsx